/**
 * 页面可见状态 Hook
 */
import { useEffect } from 'react';
import Grounds from '../index';
export const usePageActive = (callback) => {
    const isAndroid = /android/i.test(Grounds.getDeviceInfo().getOs());
    useEffect(() => {
        let eventHandler = (e) => {
            if (document.visibilityState === 'visible') {
                callback();
            }
        };
        if (isAndroid) {
            Grounds.onEvent('active', callback);
        }
        else {
            document.addEventListener('visibilitychange', eventHandler);
        }
        return () => document.removeEventListener('visibilitychange', eventHandler);
    }, []);
};
